import { formConnectFactory } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/shared/Form.connect';
import { connect } from 'react-redux';
import { liveFormInputSelectors } from 'state/secondaryMarket/live/form/input/inputForm.selectors';
import { liveSelectors } from 'state/secondaryMarket/live/live.selector';
import { liveThunks } from 'state/secondaryMarket/live/live.thunk';
import { liveReferentialSelectors } from 'state/secondaryMarket/live/referential/liveReferential.selector';

const { mapStateToProps, mapDispatchToProps } = formConnectFactory(
  liveReferentialSelectors,
  liveSelectors,
  liveFormInputSelectors,
  liveThunks,
);
export const connectLiveForm = connect(mapStateToProps, mapDispatchToProps);
